import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const CategoriesModule = lazy(loadModule);

export default CategoriesModule;
